export default class filters {
    constructor() {
        this.checkFilters = this.checkFilters.bind(this);
        this.updateTemplateFiltersState = this.updateTemplateFiltersState.bind(this);
        this.handleDesktopModeChange = this.handleDesktopModeChange.bind(this);
        this.navigateToAllProducts = this.navigateToAllProducts.bind(this);
        this.desktopMediaQuery = null;
        this.init();
    }

    init() {
        const par = this;
        this.$filters = $('.filters');
        this.$templateCollections = $('.template-collection');
        this.currentCollectionHandle = this.$filters && this.$filters.length ? this.$filters.data('current-collection') : null;

        this.setupDesktopDefault();

        $('.filters ul > span').on('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            $(this).toggleClass('open');
        });

        $('button.toggle-filters').on('click', function (e) {
            e.preventDefault();
            par.$filters.toggleClass('out');
            par.updateTemplateFiltersState();
        });

        $('.filters .clear').off('click').on('click', function (e) {
            if (par.shouldRedirectToDefaultCollection()) {
                e.preventDefault();
                par.navigateToAllProducts();
                return;
            }
            $(this).closest('.filters').find('input:not([data-name="categorys"])').prop('checked', false);
            $(this).closest('.filters').find('input').first().trigger('change');
            $('.filters input.search').val(''); // Clear search input
            par.syncPriceQueryParam(null);
            par.checkFilters();
        });

        $('.filters label').on('click', function (e) {
            if ($(e.target).is('label')) {
                e.preventDefault();
                e.stopPropagation();
                $(this).find('input').prop('checked', !$(this).find('input').prop('checked')).trigger('change');
            }
            par.checkFilters();
        });

        $('.filters input').on('change', function () {
            par.checkFilters();
        });

        $('.filters input[type="radio"]').off('change').on('change', function () {
            const groupName = $(this).attr('data-name');
            $('.filters input[type="radio"][data-name="' + groupName + '"]').not(this).prop('checked', false);
            if (groupName === 'price') {
                if ($(this).is(':checked')) {
                    par.syncPriceQueryParam($(this));
                } else {
                    par.syncPriceQueryParam(null);
                }
            } else if (groupName === 'collection_special') {
                if ($(this).is(':checked')) {
                    const targetUrl = $(this).data('collection-url');
                    if (targetUrl) {
                        window.location = targetUrl;
                        return;
                    }
                } else if (par.isCurrentCollectionSpecial(this)) {
                    par.navigateToAllProducts();
                    return;
                }
            } else {
                par.checkFilters();
            }
        });

        // Search input on keyup
        $('.filters input.search').on('keyup', function () {
            par.checkFilters();
        });

        par.prefillSearchFromUrl();
        par.applyFiltersFromUrl();
        par.checkFilters();
        par.expandActiveFilterGroups();
        par.updateTemplateFiltersState();
    }

    checkFilters() {
        const par = this;
        const additiveFilterTypes = ['artists', 'techniques', 'themes'];
        const additiveAttrMap = {
            artists: 'data-artist',
            techniques: 'data-technique',
            themes: 'data-themes'
        };
        const additiveSelections = {};
        const baseFilters = [];
        const filters = $('.filters input:checked');

        filters.each(function () {
            const $filter = $(this);
            const filterType = ($filter.attr('data-name') || '').toLowerCase();
            const isRadio = $filter.attr('type') === 'radio';
            const isAdditive = !isRadio && additiveFilterTypes.indexOf(filterType) >= 0;

            if (isAdditive) {
                const value = $filter.attr('data-filter');
                if (value) {
                    if (!additiveSelections[filterType]) {
                        additiveSelections[filterType] = [];
                    }
                    additiveSelections[filterType].push(value);
                }
            } else if (filterType !== 'collection_special') {
                baseFilters.push(this);
            }
        });

        let searchText = $('.filters input.search').length > 0 ? $('.filters input.search').val().toLowerCase() : null;
        const $items = $('.product-item');
        const $emptyNote = $('[data-empty-filter-note]');

        $items.hide();

        $items.each(function () {
            let item = $(this);
            let isMatch = true;

            baseFilters.forEach(function (filterEl) {
                const $filter = $(filterEl);
                let filterType = ($filter.attr('data-name') || '').toLowerCase();
                let filterValue = $filter.attr('data-filter');

                if ($filter.attr('type') === 'radio' && !$filter.is(':checked')) {
                    return;
                }

                if (filterType === 'price') {
                    let [min, max] = $filter.attr('data-price').split('–').map(Number);
                    let itemPrice = parseInt(item.attr('data-price'));
                    if (itemPrice < min || itemPrice > max) isMatch = false;
                } else if (filterType === 'size' || filterType === 'size category') {
                    const normalizedFilter = par.normalizeToken(filterValue);
                    const sizeAttr = item.attr('data-size_category') || '';
                    const productSizes = sizeAttr
                        .split(',')
                        .map(value => par.normalizeToken(value))
                        .filter(Boolean);
                    if (!normalizedFilter || !productSizes.length || productSizes.indexOf(normalizedFilter) === -1) {
                        isMatch = false;
                    }
                } else if (filterType === 'autographed' && (!item.attr('data-autographed') || item.attr('data-autographed').indexOf('yes') < 0)) {
                    isMatch = false;
                } else if (filterType === 'ready_to_hang' && (!item.attr('data-ready_to_hang') || item.attr('data-ready_to_hang').indexOf('yes') < 0)) {
                    isMatch = false;
                } else if (filterType === 'categorys' && !par.attributeHasToken(item.attr('data-category'), filterValue)) {
                    isMatch = false;
                }
            });

            if (isMatch) {
                const additiveTypes = Object.keys(additiveSelections);
                for (let i = 0; i < additiveTypes.length; i++) {
                    const type = additiveTypes[i];
                    const selections = additiveSelections[type] || [];
                    if (!selections.length) {
                        continue;
                    }

                    const attrName = additiveAttrMap[type];
                    const attrValue = attrName ? (item.attr(attrName) || '') : '';
                    if (!attrValue) {
                        isMatch = false;
                        break;
                    }

                    const matchesAny = selections.some(function (selection) {
                        return attrValue.indexOf(selection) >= 0;
                    });

                    if (!matchesAny) {
                        isMatch = false;
                        break;
                    }
                }
            }

            // Text search filtering
            if (searchText && searchText.length > 0) {
                let itemText = item.text().toLowerCase();
                if (!itemText.includes(searchText)) {
                    isMatch = false;
                }
            }

            if (isMatch) {
                item.show();
            }
        });

        const visibleCount = $items.filter(':visible').length;
        this.updateResultsCount(visibleCount);

        if ($emptyNote.length) {
            const hasItems = $items.length > 0;
            $emptyNote.toggleClass('is-visible', hasItems && visibleCount === 0);
        }

    }

    applyFiltersFromUrl() {
        if (typeof window === 'undefined') return;
        const params = new URLSearchParams(window.location.search);
        const priceParam = params.get('price');
        if (!priceParam) return;

        const normalized = this.normalizePriceParam(priceParam);
        if (!normalized) return;

        const priceInput = $('.filters input[data-name="price"][data-price="' + normalized + '"]');
        if (!priceInput.length) return;

        priceInput.prop('checked', true);
        this.syncPriceQueryParam(priceInput);
    }

    prefillSearchFromUrl() {
        if (typeof window === 'undefined') return;
        const params = new URLSearchParams(window.location.search);
        const searchParam = params.get('search') || params.get('q');
        if (!searchParam) return;

        const cleaned = this.normalizeSearchQuery(searchParam);
        if (!cleaned) return;

        const $searchInput = $('.filters input.search');
        if (!$searchInput.length) return;

        $searchInput.val(cleaned);
    }

    normalizeSearchQuery(value) {
        if (!value) return '';
        return value
            .toString()
            .replace(/\+/g, ' ')
            .replace(/\*/g, '')
            .trim();
    }

    normalizePriceParam(value) {
        if (!value) return null;
        let normalized = value.toString().trim();
        if (!normalized) return null;

        normalized = normalized.replace(/\s+/g, '');
        normalized = normalized.replace(/\+/g, '-');
        normalized = normalized.replace(/\u2012|\u2013|\u2014|\u2015/g, '–');
        normalized = normalized.replace(/-/g, '–');

        if (normalized.endsWith('–')) {
            normalized = normalized + '999999';
        }

        return normalized;
    }

    formatPriceForQuery(range) {
        if (!range) return null;
        let formatted = range.toString().trim();
        if (!formatted) return null;

        formatted = formatted.replace(/\s+/g, '');
        formatted = formatted.replace(/\u2012|\u2013|\u2014|\u2015/g, '-');

        const parts = formatted.split('-').filter(Boolean);
        if (!parts.length) return null;

        if (parts.length === 1) {
            // Open-ended range like 1500–999999
            return parts[0] + '-';
        }

        if (parts[1] === '999999') {
            return parts[0] + '-';
        }

        return parts[0] + '-' + parts[1];
    }

    syncPriceQueryParam(selectedInput) {
        if (typeof window === 'undefined' || !window.history || !window.history.replaceState) return;
        const url = new URL(window.location.href);
        if (!selectedInput || !selectedInput.length) {
            url.searchParams.delete('price');
            window.history.replaceState({}, '', url.toString());
            return;
        }

        const range = selectedInput.attr('data-price');
        const paramValue = this.formatPriceForQuery(range);
        if (paramValue) {
            url.searchParams.set('price', paramValue);
        } else {
            url.searchParams.delete('price');
        }
        window.history.replaceState({}, '', url.toString());
    }

    normalizeToken(value) {
        if (value === undefined || value === null) {
            return '';
        }
        return value.toString().trim().toLowerCase().replace(/\s+/g, '-');
    }

    setupDesktopDefault() {
        if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
            this.updateTemplateFiltersState();
            return;
        }

        this.desktopMediaQuery = window.matchMedia('(min-width: 801px)');
        this.handleDesktopModeChange(this.desktopMediaQuery);

        if (typeof this.desktopMediaQuery.addEventListener === 'function') {
            this.desktopMediaQuery.addEventListener('change', this.handleDesktopModeChange);
        } else if (typeof this.desktopMediaQuery.addListener === 'function') {
            this.desktopMediaQuery.addListener(this.handleDesktopModeChange);
        }
    }

    handleDesktopModeChange(query) {
        if (!this.$filters || !this.$filters.length) {
            this.updateTemplateFiltersState();
            return;
        }

        if (query && query.matches) {
            this.$filters.removeClass('out');
        } else if (query) {
            this.$filters.addClass('out');
        }

        this.updateTemplateFiltersState();
    }

    updateTemplateFiltersState() {
        if (!this.$templateCollections || !this.$templateCollections.length) {
            return;
        }

        const filtersOpen = this.$filters && this.$filters.length && !this.$filters.hasClass('out');
        this.$templateCollections.toggleClass('filters-in', !!filtersOpen);
    }

    expandActiveFilterGroups() {
        $('.filters ul > span').each(function () {
            const $span = $(this);
            const hasChecked = $span.siblings('ul').find('input:checked').length > 0;
            if (hasChecked) {
                $span.addClass('open');
            }
        });
    }

    isCurrentCollectionSpecial(inputEl) {
        if (!inputEl || !this.currentCollectionHandle) {
            return false;
        }
        return inputEl.getAttribute('data-filter') === this.currentCollectionHandle;
    }

    getSpecialCollectionHandles() {
        return $('.filters input[data-name="collection_special"]').map(function () {
            return (this.getAttribute('data-filter') || '').trim();
        }).get();
    }

    shouldRedirectToDefaultCollection() {
        if (!this.currentCollectionHandle) {
            return false;
        }
        const specials = this.getSpecialCollectionHandles();
        return specials.indexOf(this.currentCollectionHandle) >= 0;
    }

    navigateToAllProducts() {
        window.location = '/collections/all-products';
    }

    updateResultsCount(count) {
        const $countTarget = $('[data-filter-count]');
        if (!$countTarget.length) {
            return;
        }

        const label = count === 1 ? 'work' : 'works';
        $countTarget.text(`${count} ${label}`);
    }

    attributeHasToken(value, target) {
        if (!value || !target) {
            return false;
        }

        const tokens = value
            .split(/\s+/)
            .map(token => token.trim())
            .filter(Boolean);

        return tokens.indexOf(target) >= 0;
    }
}
